<template>
  <div>
    <div class="row">
      <div class="RegistrosAnterioresManual--header col text-bold">
        Adicionar registro manualmente
      </div>
      <hr>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <box-tipo v-model="manual.tipo_registro"
                  :prop-tipo-registro="manual.tipo_registro"
                  :prop-disabled="true" />
      </div>
      <div v-if="!propRegistro.index && propRegistro.index != 0"
           class="col d-flex align-items-center justify-content-left">
        <label :for="`sem_documentos_${ _uid }`"
               class="mr-2 mt-2">
          O declarante não trouxe o documento e não foi encontrada na base de dados
        </label>
        <span class="custom-control custom-switch">
          <input
            :id="`sem_documentos_${ _uid }`"
            v-model="manual.sem_documentos"
            class="custom-control-input"
            name="tipo_registro"
            :value="true"
            type="checkbox"
            @change="definirDocumento"
            @keyup.enter="changeDocumento()">
          <label
            class="custom-control-label"
            :for="`sem_documentos_${ _uid }`" />
        </span>
      </div>
    </div>

    <div class="RegistrosAnterioresManual--tipoBox p-2 pb-3">
      <div class="row mt-3">
        <div class="col-3">
          <label class="label"
                 :for="`uf_${ _uid }`">UF</label>
          <v-select :id="`uf_${ _uid }`"
                    v-model="manual.uf"
                    class="form-control form-control-sm"
                    :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                    :options="estados.map((state)=> state.uf)"
                    @input="ufChanged" />
        </div>
        <div class="col-4">
          <label class="label"
                 :for="`cidade_${ _uid }`">Cidade</label>
          <v-select :id="`cidade_${ _uid }`"
                    v-model="manual.cidade"
                    class="form-control form-control-sm"
                    :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                    :options="cidades.map(cidade => cidade.nome)"
                    @input="onSelectCidade()" />
        </div>
        <div class="col">
          <label class="label"
                 :for="`cartorio_${ _uid }`">Cartório</label>
          <v-select :id="`cartorio_${ _uid }`"
                    v-model="manual.nome_cartorio"
                    v-validate="`${(cartorios.length > 0) ? 'required' : ''}`"
                    :name="`cartorio_${ _uid }`"
                    value="nome"
                    :class="{ 'is-invalid': errors.has(`cartorio_${ _uid }`) }"
                    class="form-control form-control-sm RegistrosAnterioresManual--selectHeight"
                    :options="cartorios.map(cartorio => cartorio.NOME)"
                    :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                    @input="cartorioChanged()" />
          <small v-if="cartorios.length == 0 && show.cartorioMsg"
                 class="text-danger">
            Nenhum cartorio encontrado com esse UF e Cidade
          </small>
          <small v-if="errors.has(`cartorio_${ _uid }`)"
                 class="text-danger">
            {{ errors.first(`cartorio_${ _uid }`) }}
          </small>
        </div>
      </div>

      <div v-if="manual.tipo_registro == 'C'"
           class="row mt-1">
        <div class="col-3">
          <label :for="`manual_cpf_conjugue_${ _uid }`"
                 class="label">
            CPF do Cônjuge
          </label>
          <input :id="`manual_cpf_conjugue_${ _uid }`"
                 v-model="manual.cpf_conjuge"
                 v-mask="'999.999.999-99'"
                 type="text"
                 class="form-control form-control-sm">
        </div>
        <div class="col">
          <label :for="`manual_nome_conjugue_${ _uid }`"
                 class="label">
            Nome do Cônjuge
          </label>
          <input :id="`manual_nome_conjugue_${ _uid }`"
                 v-model.lazy="manual.conjuge"
                 v-uppercase
                 :name="`manual_nome_conjugue_${ _uid }`"
                 type="text"
                 :class="{ 'is-invalid': errors.has(`manual_nome_conjugue_${ _uid }`) }"
                 class="form-control form-control-sm text-uppercase">

          <small v-if="errors.has(`manual_nome_conjugue_${ _uid }`)"
                 class="text-danger">
            {{ errors.first(`manual_nome_conjugue_${ _uid }`) }}
          </small>
        </div>
        <div class="col">
          <label :for="`manual_nome_registrado_${ _uid }`"
                 class="label">
            Nome do registrado
          </label>
          <input :id="`manual_nome_registrado_${ _uid }`"
                 v-model.lazy="manual.nome_registrado"
                 v-validate="{required: !manual.sem_documentos}"
                 v-uppercase
                 :name="`manual_nome_registrado_${ _uid }`"
                 :class="{ 'is-invalid': errors.has(`manual_nome_registrado_${ _uid }`) }"
                 type="text"
                 class="form-control form-control-sm text-uppercase">
          <small v-if="errors.has(`manual_nome_registrado_${ _uid }`)"
                 class="invalid-feedback">
            {{ errors.first(`manual_nome_registrado_${ _uid }`) }}
          </small>
        </div>
      </div>

      <div v-if="manual.tipo_registro == 'C'"
           class="row mt-1">
        <div class="col-3">
          <label :for="`manual_data_casamento_${ _uid }`"
                 class="label">
            Data de Casamento
          </label>
          <input :id="`manual_data_casamento_${ _uid }`"
                 v-model="manual.data_ocorrido"
                 v-validate="`max_date:${new Date()}`"
                 :name="`manual_data_casamento_${ _uid }`"
                 type="date"
                 :class="{ 'is-invalid': errors.has(`manual_data_casamento_${ _uid }`) }"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 class="form-control form-control-sm">
          <small v-if="errors.has(`manual_data_casamento_${ _uid }`)"
                 class="invalid-feedback">
            {{ errors.first(`manual_data_casamento_${ _uid }`) }}
          </small>
        </div>
        <div class="col-3">
          <label :for="`manual_registro_casamento_anterior_${ _uid }`"
                 class="label">
            Data do registro do casamento
          </label>
          <input :id="`manual_registro_casamento_anterior_${ _uid }`"
                 v-model="manual.data_registro"
                 v-validate="`max_date:${new Date()}`"
                 :name="`manual_registro_casamento_anterior_${ _uid }`"
                 type="date"
                 :class="{ 'is-invalid': errors.has(`manual_registro_casamento_anterior_${ _uid }`) }"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 class="form-control form-control-sm">
          <small v-if="errors.has(`manual_registro_casamento_anterior_${ _uid }`)"
                 class="invalid-feedback">
            {{ errors.first(`manual_registro_casamento_anterior_${ _uid }`) }}
          </small>
        </div>
        <div class="col-3">
          <label :for="`manual_data_dissolucao_casamento_${ _uid }`"
                 class="label">
            Data dissolução do casamento
          </label>

          <input :id="`manual_data_dissolucao_casamento_${ _uid }`"
                 v-model="manual.data_dissolucao_casamento"
                 v-validate="`max_date:${new Date()}`"
                 :name="`manual_data_dissolucao_casamento_${ _uid }`"
                 type="date"
                 :class="{ 'is-invalid': errors.has(`manual_data_dissolucao_casamento_${ _uid }`) }"
                 class="form-control form-control-sm">
          <small v-if="errors.has(`manual_data_dissolucao_casamento_${ _uid }`)"
                 class="invalid-feedback">
            {{ errors.first(`manual_data_dissolucao_casamento_${ _uid }`) }}
          </small>
        </div>
      </div>

      <div v-if="manual.tipo_registro == 'C'"
           class="row mt-1">
        <div class="col-4">
          <label :for="`regime_bens_${ _uid }`"
                 class="label">
            Regime de bens anterior
          </label>
          <v-select :id="`regime_bens_${ _uid }`"
                    v-model="manual.regime_bens"
                    class="form-control form-control-sm"
                    :options="regime_bens" />
        </div>
        <div class="col-4">
          <label :for="`n_filhos_${ _uid }`"
                 class="label">
            Nº de filhos do casamento anterior
          </label>
          <div class="row">
            <div class="col-6">
              <input v-model="manual.qtd_filhos"
                     type="text"
                     class="form-control form-control-sm">
            </div>
          </div>
        </div>
      </div>

      <div v-if="manual.tipo_registro != 'C'"
           class="row mt-1">
        <div class="col-3">
          <label :for="`manual_cpf_${ _uid }`"
                 class="label">
            CPF
          </label>
          <input :id="`manual_cpf_${ _uid }`"
                 v-model="manual.cpf_registrado"
                 v-mask="'999.999.999-99'"
                 type="text"
                 class="form-control form-control-sm"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)">
        </div>
        <div class="col">
          <label :for="`manual_nome_registrado_${ _uid }`"
                 class="label">
            Nome do registrado
          </label>
          <input :id="`manual_nome_registrado_${ _uid }`"
                 v-model="manual.nome_registrado"
                 v-validate="{ required: true }"
                 v-uppercase
                 :name="`manual_nome_registrado_${ _uid }`"
                 :class="{ 'is-invalid': errors.has(`manual_nome_registrado_${ _uid }`) }"
                 type="text"
                 class="form-control form-control-sm">
          <small v-if="errors.has(`manual_nome_registrado_${ _uid }`)"
                 class="invalid-feedback">
            {{ errors.first(`manual_nome_registrado_${ _uid }`) }}
          </small>
        </div>
        <div class="col-3">
          <label :for="`manual_data_nascimento_${ _uid }`"
                 class="label">
            Data de Nascimento
          </label>
          <input :id="`manual_data_nascimento_${ _uid }`"
                 v-model="manual.data_ocorrido"
                 v-validate="`max_date:${new Date()}`"
                 type="date"
                 :name="`manual_data_nascimento_${ _uid }`"
                 :class="{ 'is-invalid': errors.has(`manual_data_nascimento_${ _uid }`) }"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 class="form-control form-control-sm">
          <small v-if="errors.has(`manual_data_nascimento_${ _uid }`)"
                 class="invalid-feedback">{{ errors.first(`manual_data_nascimento_${ _uid }`) }}</small>
        </div>
      </div>


      <div class="row mt-1">
        <div class="col-6">
          <label :for="`manual_matricula_${ _uid }`"
                 class="label">
            Matrícula
          </label>
          <input :id="`manual_matricula_${ _uid }`"
                 v-model="manual.matricula"
                 v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                 type="text"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 class="form-control form-control-sm">
        </div>
        <div class="col-1 col-sm-2">
          <label :for="`manual_matricula_${ _uid }`"
                 class="label">
            Livro
          </label>
          <input :id="`manual_matricula_${ _uid }`"
                 v-model="manual.livro"
                 v-zero-before
                 maxlength="5"
                 type="number"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 name="livro-manual"
                 class="form-control form-control-sm"
                 :class="{'is-invalid' : errors.has('livro-manual')}">
          <small class="invalid-feedback">{{ errors.first('livro-manual') }}</small>
        </div>
        <div class="col-1 col-sm-2">
          <label :for="`manual_matricula_${ _uid }`"
                 class="label">
            Folha
          </label>
          <input :id="`manual_matricula_${ _uid }`"
                 v-model="manual.folha"
                 v-zero-before
                 maxlength="3"
                 type="number"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 name="folha-manual"
                 class="form-control form-control-sm"
                 :class="{'is-invalid' : errors.has('folha-manual')}">
          <small class="invalid-feedback">{{ errors.first('folha-manual') }}</small>
        </div>
        <div class="col-1 col-sm-2">
          <label :for="`manual_matricula_${ _uid }`"
                 class="label">
            Termo
          </label>
          <input :id="`manual_matricula_${ _uid }`"
                 v-model="manual.termo"
                 v-zero-before
                 maxlength="7"
                 type="number"
                 :disabled="manual.origem == 'CRC' || (manual.origem == 'MANUAL' && !!manual.comunicacao_crc_status_local)"
                 name="termo-manual"
                 class="form-control form-control-sm"
                 :class="{'is-invalid' : errors.has('termo-manual')}">
          <small class="invalid-feedback">{{ errors.first('termo-manual') }}</small>
        </div>
      </div>
    </div>
    <div class="row pt-2 pb-3">
      <div class="col text-right">
        <hr class="RegistrosAnteriores--hr pt-0 mt-0">
        <b-button size="sm"
                  variant="light"
                  @click="goToBack">
          Voltar
        </b-button>
        <b-button size="sm"
                  class="ml-2"
                  variant="secondary"
                  @click="vincular">
          Vincular
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  /* constants */
  import brazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades"

  /* components */
  import BoxTipo from "@/components/SofiaRei/BoxTipo"

  /* services */
  import CartorioService from "@/services/CartorioService"

  /* helper */
  import moment from 'moment'

  export default {
    name: "RegistrosAnterioresManual",
    components: {
      BoxTipo
    },
    inject: ['$validator'],
    props: {
      propRegistro: {
        type: Object,
        default: () => {
          return {
            index: null,
            registro: {}
          }
        }
      },
      propBusca: {
        type: Object,
        default: () => ({})
      },
      propData: {
        type: Object,
        default: () => ({})
      },
      propTipoRegistro: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        index: null,
        show: {
          cartorioMsg: false
        },
        estados: [...brazilianStates],
        regime_bens: [
          "Comunhão parcial de bens",
          "Comunhão universal de bens",
          "Participação final aquestos",
          "Separação de Bens",
          "Separação legal de bens",
          "Outros",
          "Ignorado"
        ],
        cidades: [],
        cartorios: [],
        manual: {
          registrado: null,
          num_cnj: null,
          uf: null,
          cidade: null,
          cartorio: null,
          nome_cartorio: null,
          cpf_registrado: null,
          nome_registrado: null,
          matricula: null,
          tipo_registro: 'N',
          livro: null,
          folha: null,
          termo: null,
          nome_genitor1_completo: null,
          nome_genitor2_completo: null,
          data_registro: null,
          data_registro_inicio: null,
          data_registro_fim: null,
          data_ocorrido: null,
          data_ocorrido_inicio: null,
          data_ocorrido_fim: null,
          /* só para casamento*/
          nome_reg_1_completo: null,
          nome_reg_2_completo: null,
          cpf_conjuge: null,
          conjuge: null,
          regime_bens: null,
          sem_documentos: false,
          data_dissolucao_casamento: null
        },
      }
    },
    created () {
      if (Object.values(this.propRegistro.registro).length != 0) {
        Object.assign(this.manual, this.propRegistro.registro)
      } else if (Object.values(this.propBusca).length > 0) {
        Object.assign(this.manual, this.propBusca)
      }
      if (this.manual && this.manual.uf) {
        this.ufChanged(false)
      }

      // caso a posição do registrado esteja como conjugue, invertemos
      if (this.manual.registrado == 'conjuge') {
        // guardados numa const
        const registradoBkp = this.manual.nome_registrado
        const conjugueBkp = this.manual.conjuge

        // invertemos
        this.manual.nome_registrado = conjugueBkp
        this.manual.conjuge = registradoBkp
      }

      if (!!this.propTipoRegistro) {
        this.manual.tipo_registro = this.propTipoRegistro
      }

      if (this.propRegistro.index != null) {
        this.index = this.propRegistro.index
      }
      // this.changed()
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        if (this.propRegistro.registro && !this.propRegistro.registro.data_ocorrido) {
          if (this.propRegistro.registro.tipo_registro === 'C') {
            this.manual.data_registro = null
          } else {
            if (!this.propData.data_nascimento) {
              this.manual.data_ocorrido = null
              return
            }

            const data_nascimento = moment(this.propData.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')

            /**
             * A data de nascimento fica no formato inválido quando ela já está
             * no formato correto e não precisa ser formatada, por isso passamos
             * ela diretamente para a data_ocorrido
             */
            if (data_nascimento === 'Invalid date' || data_nascimento === 'Data inválida') {
              this.manual.data_ocorrido = this.propData.data_nascimento
            } else {
              this.manual.data_ocorrido = data_nascimento
            }

            if (this.manual.tipo_registro == 'C') {
              this.manual.data_ocorrido = null
            }
          }
        }
      },
      async ufChanged (original = true) {
        try {
          // loader({ active: true, text: 'Carregando cidades por estado' })
          // pegando estado
          const state = this.estados.find(estado => estado.uf == this.manual.uf)
          const cities = Cidades.filter(cidade => cidade.codigo_uf == state.ibgeId)
          this.cidades = cities
          if (original) {
            this.manual.cidade = null
          } else {
            this.onSelectCidade(original)
          }
          // this.changed()
        } finally {
          loader({ active: false })
        }
      },
      cartorioChanged () {
        this.$validator.validate(`cartorio_${ this._uid }`)
          .then(resp => {
            if (resp) {
              const cartorioSelecionado = this.cartorios.find(cartorio => cartorio.NOME == this.manual.nome_cartorio)

              this.manual = {
                ...this.manual,
                cartorio_id: cartorioSelecionado.CARTORIO_ID,
                cns: cartorioSelecionado.NUM_CNJ,
                cartorio_nome: cartorioSelecionado.NOME,
              }
            }
          })
      },
      changeDocumento () {
        this.manual.sem_documentos = !this.manual.sem_documentos
        this.definirDocumento()
      },
      definirDocumento () {
        if (this.manual.sem_documentos) {
          Object.keys(this.manual).forEach(item => {
            if (item !== 'sem_documentos' && item !== 'tipo_registro' ) {
              this.manual[item] = null
            }
          })
        }
      },
      changed () {
        this.$emit('onChanged', this.index, this.manual)
      },
      upperName () {
        if (this.manual.conjuge) {
          this.manual.conjuge = this.manual.conjuge.toUpperCase()
        }
        if (this.manual.nome_registrado) {
          this.manual.nome_registrado = this.manual.nome_registrado.toUpperCase()
        }
      },
      validaCampoRecebidoCRC (campo) {
        return !!this.manual.sem_documentos || this.manual[campo] ? this.manual[campo] === this.propRegistro.registro[campo] : false
      },
      async pesquisarCartorios (cidadeNome = null, original = true) {
        try {
          loader({ active: true, text: `Pesquisando Cartórios...` })
          const query = {}

          if (this.manual.uf && this.manual.cidade) {
            query.acao = 'endereco'
            query.uf = this.manual.uf
            query.cidade = cidadeNome || this.manual.cidade
          }

          const { data: { result } } = await CartorioService.pesquisarCartorios(query)

          if (result.cartorios) this.cartorios = result.cartorios

          if (original) this.manual.nome_cartorio = null

          if (this.cartorios.length == 0) {
            this.show.cartorioMsg = true
          } else {
            this.show.cartorioMsg = false
          }

        } finally {
          loader({ active: false })
        }
      },
      async onSelectCidade (original = true) {
        const cidade = this.cidades.find(cidade => cidade.nome == this.manual.cidade)

        if (cidade && (!this.propRegistro.registro.nome_cartorio && !this.validaCampoRecebidoCRC('nome_cartorio'))) {
          this.pesquisarCartorios(cidade.nome, original)
          this.$validator.validate(`cartorio_${ this._uid }`)
        }
      },
      goToBack () {
        this.$emit('onGoToBack')
      },
      vincular () {
        if (this.manual.origem != 'CRC') {
          this.manual.origem = 'MANUAL'
        }      

        this.changed()
        this.$validator.validate().then(resp => {
          if (resp) {
            this.upperName()
            this.$emit('onChanged', this.index, this.manual)
            this.$emit('onVincular')
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scss/_utilities/_exports";

  .RegistrosAnterioresManual {
    &--header {
      background-color: $sofiaRei-blue;
      padding: 3px 15px;
    }

    &--tipoBox {
      border: 4px solid $sofiaRei-blue;
    }

    &--selectHeight {
      height: auto;
    }

  }
</style>
